import { render, staticRenderFns } from "./StorageSystemEdit.vue?vue&type=template&id=fb4aaa6c&scoped=true"
import script from "./StorageSystemEdit.vue?vue&type=script&lang=js"
export * from "./StorageSystemEdit.vue?vue&type=script&lang=js"
import style0 from "./StorageSystemEdit.vue?vue&type=style&index=0&id=fb4aaa6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4aaa6c",
  null
  
)

export default component.exports